module.exports = __webpack_public_path__ + "assets/img/lesson_parent_pk.d4c8d420.png";